<!-- Command Palette Container -->
@if (isOpen) {
<div class="command-palette-container backdrop-blur-sm select-none" (click)="onBackdropClick($event)"
  (keydown)="onKeyDown($event)">
  <!-- Command Palette -->
  <div class="command-palette bg-surface rounded-2xl theme-border" [@palette] (click)="onPaletteClick($event)">
    <!-- Search Input -->
    <div class="flex items-center border-b border-outline-color w-full max-w-full">
      <div class="command-palette-search bg-surface flex-1">
        <div class="search-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </div>
        <input #searchInput type="text" class="search-input max-w-56 md:max-w-full" [placeholder]="placeholder"
          [(ngModel)]="searchModel" (ngModelChange)="onSearchChange($event)" (keydown)="onSearchKeyDown($event)"
          autocomplete="off" autocorrect="off" autocapitalize="words" spellcheck="false" [enterKeyHint]="'search'" />
        <!-- @if (searchModel) {
        <app-icon-button [tabIndex]="-1" [config]="{
        icon: 'close',
        size: 'xs',
        color: 'red',
        border: true,
        shadow: false,
      }" (click)="searchModel = ''; onSearchChange('')"></app-icon-button>
        } -->
      </div>
      <!-- Close button -->
      <div class="pr-6">
        <app-icon-button [tabIndex]="-1" [config]="{
      icon: 'close',
      size: 'sm',
      color: 'red',
      border: true,
      shadow: true,
    }" (click)="onClose()"></app-icon-button>
      </div>
    </div>
    <!-- Divider -->
    <div class="command-palette-divider"></div>

    <!-- Main Content (Dynamic Template) -->
    <div class="command-palette-content">
      @if (contentTemplate) {
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      } @else {
        <div class="text-sm text-medium py-8 text-center">
          No content available
        </div>
      }
    </div>
  </div>
</div>
}